<div class="custom-field-details__wrapper">
  <dl *ngIf="view === customFieldDetailsView.LIST" class="dl-grid dl-grid--inline">
    <ng-container
      *ngFor="let customFieldValue of customFieldValuesUI; trackBy: trackById"
    >
      <dt>{{ customFieldValue?.label }}:&nbsp;</dt>
      <dd>{{ customFieldValue?.value }}</dd>
    </ng-container>
  </dl>

  <table
    class="lum-table lum-table--classic striped"
    *ngIf="view === customFieldDetailsView.TABLE"
  >
    <thead>
      <th>Field</th>
      <th>Value</th>
    </thead>
    <tbody>
      <tr *ngFor="let customFieldValue of customFieldValuesUI; trackBy: trackById">
        <td>{{ customFieldValue?.label }}</td>
        <td>{{ customFieldValue?.value }}</td>
      </tr>
    </tbody>
  </table>
</div>
